import styled from "styled-components";
import { colors } from "../../../assets";


export const CampaignsManagementContainer = styled.div`
  .col-1 {width: 8.33% !important;}
  .col-2 {width: 16.66%; !important}
  .col-3 {width: 25%;}
  .col-4 {width: 33.33%;}
  .col-5 {width: 41.66%;}
  .col-6 {width: 50%;}
  .col-7 {width: 58.33%;}
  .col-8 {width: 66.66%;}
  .col-9 {width: 75%;}
  .col-10 {width: 83.33%;}
  .col-11 {width: 91.66%;}
  .col-12 {width: 100%;}
  
  .campaings-title {
    width: max-content;
  }

  .main-title-container-complex {
    margin-bottom: 38px;
    color: #004F8B;
    width: auto;
    display: flex;
  }

  .main-title-container-complex-item {  
      margin-right: 58%;    
  }

  
  .tabs-container {
    position: relative;
    width: fit-content;
    margin-bottom: 35px;
    &__tabs {
      display: flex;
      border-bottom: 0.5px solid #B5BCC6;
      padding: 0 20px 12px;
      div {
        cursor: pointer;
        font-size: 16px;
        line-height: 17px;
        text-transform: uppercase;
        color: #B5BCC6;
        transition: color .2s ease-in-out;
        &:first-child {
          margin-right: 28px;
        }
      }
      .selected {
        color: #004F8B;
      }
    }
    &__line {
      border-top: 4px solid #004F8B;
      width: 205px;
      position: absolute;
      bottom: -1px;
      right: auto;
      transition: right .2s ease-in-out;
      right: 0px;
    }
    .selected-right {
      left: 0;
    }
  }

  .main-filter-container {
    width: 100%;
    margin-bottom: 15px;
    background-color: #fbfbfb;
    padding: 20px;

    .keep-calm {
      padding: 1px 3px;
      background: ${colors["AL-001-20"]};
      font-size: 15px;
      margin-bottom: 30px;
  
      p {
        color: ${colors["SC-004-100"]};
        padding-right: 0;
      }
    }
  }

`;
